/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251228
*/
'use strict';

import {
    bindSelect,
    getUrlParam, 
} from './ctssHtml.js';
import {
    allSettled,
    getPromise,
    savePromise,
    showMySNError
} from './ctssJQuery.js';
import {
    appDebugMode,
    getAppToken,
    refreshTokenForSubscriptionStatusAsync,
    setMenu
} from './snSite.js';
import {
    buildStripeCard,
    clearStripeCard,
    getStripeToken
} from './snStripe.js';


const token = getAppToken();

const enablePreviewPlanUpdate = () => {
    $('#btnUpdatePlan, #prorationAlert').addClass('hidden');
    $('#btnPreviewUpdate').removeClass('hidden');
}

const getBillingInfoAsync = async () =>
    await getPromise({ url: `Billing/Info?cg=${token.CG}` });


const getBillingIntervalPlans = (billingInterval) => {
    const p = plans.filter(x => x.billingInterval === parseInt(billingInterval, 10)); /* filter makes clone or shallow reference copy */
    if (parseInt(billingInterval, 10) === 1) {
        /* Annual billing interval - so append 'Billed Annually' to DDL */
        //const p2 = p.map(x => ({
        //    ...x,
        //    description: `${x.description} Billed Annually`
        //}));
        const p2 = [];
        p.forEach(x => {
            let plan = JSON.parse(JSON.stringify(x));
            plan.Description = plan.Description + ' Billed Annually';
            p2.push(plan);
        })

        return p2;
    }
    return p;
}

const getInvoiceRow = (params) => {

    const isPaid = params.invoice.status_transitions.paid_at !== null;

    const getCharge = (charge) => {
        return charge < 0
            ? `<td style="text-align: right;color: green;font-weight:bold;">+${(charge * -1 / 100.00).toFixed(2)}</td>`
            : `<td style="text-align: right;" >${(charge / 100.00).toFixed(2)}</td>`;
    }

    const getDownloadInvoiceCell = (params) => {
        return '<td style="text-align: right;"><span class="fa fa-file-pdf-o" title="Download invoice" onclick="window.location=\'' +
            params.invoice.invoice_pdf + '\'"></span ></td >';
    }
    const getPaidCell = () => {
        return `</td><td><span style="background-color: green; color: white; padding: 1px 2px; border-radius: 4px">${isPaid ? 'Paid' : ''}</span></td>`;
    }
    const getTransDateCell = (params) => {
        return '<td>' + ctssFormat.formatTimeStampToDateTime({
            timeStamp: isPaid ? params.invoice.status_transitions.paid_at : params.invoice.period_end,
            showDateOnly: true
        }) + '</td>';
    }

    let plan = params.invoice.lines.data[0].price.nickname;
    let row = '';
    if (params.invoice.billing_reason === 'subscription_cycle') {
        row = `<tr>${getTransDateCell(params)}${getPaidCell()}<td>${plan}</td>` +
            `${getCharge(params.invoice.total)}${getDownloadInvoiceCell(params)}</tr>`;
    } else if (params.invoice.billing_reason === 'subscription_create') {
        row = `<tr>${getTransDateCell(params)}${getPaidCell()}` +
            `<td>${params.invoice.lines.data[0].price.recurring.trial_period_days} day trial for ${plan}</td>` +
            `${getCharge(params.invoice.total)}${getDownloadInvoiceCell(params)}</tr>`;
    } else if (params.invoice.billing_reason === 'subscription_update') {
        let idx = params.invoice.lines.data.findIndex(x => x.proration === false);
        if (idx > -1) {
            row += `<tr>${getTransDateCell(params)}${getPaidCell()}` +
                `<td>${params.invoice.lines.data[idx].plan.nickname}</td>` +
                `${getCharge(params.invoice.lines.data[idx].amount)}${getDownloadInvoiceCell(params)}</tr>`;
        }
        idx = params.invoice.lines.data.findIndex(x => x.proration === true && x.amount > 0);
        if (idx > -1) {
            const s = params.invoice.lines.data[idx].description;
            let desc = 'Prorated charge for ' + s.substring(18, s.indexOf('after'));
            row += `<tr>${getTransDateCell(params)}${getPaidCell()}<td>${desc}</td>` +
                `${getCharge(params.invoice.lines.data[idx].amount)}${getDownloadInvoiceCell(params)}</tr>`;
        }
        idx = params.invoice.lines.data.findIndex(x => x.proration === true && x.amount < 0);
        if (idx > -1) {
            const s = params.invoice.lines.data[idx].description;
            let desc = 'Prorated credit for unused ' + s.substring(15, s.indexOf('after'));
            row += `<tr><td></td><td></td><td>${desc}</td>${getCharge(params.invoice.lines.data[idx].amount)}<td></td></tr>`;
        }
    }
    return row;
}

const getInvoiceRows = (params) => {
    //console.log('invoices', params.invoices);
    //const content = invoices.map(invoice => getInvoiceRow({ invoice })).join('');

    let content = '';
    for (let i = 0, l = params.invoices.length; i < l; i++) {
        content += getInvoiceRow({ invoice: params.invoices[i] });
    }
    $('#gridInvoices tbody').empty().append(content);
}

const getInvoicesAsync = async (params) => {

    const { custId, subId, status, limit } = params;

    if (!custId && !subId) {
        $('#divErrMsg').text('Customer or subscription ID must be supplied to get invoices...').removeClass('hidden');
        return;
    };

    let url = 'Billing/Invoices?';

    if (custId && subId) {
        url += 'custID=' + custId + '&subID=' + subId;
    } else if (custId) {
        url += 'custID=' + custId;
    } else {
        url += 'subID=' + subId;
    }

    if (status) {
        url += '&status=' + status;
    };
    if (limit) {
        url += '&limit=' + limit
    };

    return await getPromise({ url: url });
}

const getPreviewInvoiceAsync = async (p) =>
    await getPromise({ url: `Billing/PreviewInvoice/${p.custID}/${p.subID}/${p.priceID}` });

const getUpcomingInvoiceAsync = async (custID, subID) =>
    await getPromise({ url: `Billing/UpcomingInvoice?custID=${custID}&subID=${subID}` });

const isCardExpired = () => {
    const dt = new Date();
    const curYr = dt.getFullYear();
    const curMo = dt.getMonth() + 1;
    if (parseInt(church.billingCardInfo.ccExpYr, 10) < curYr) {
        return true;
    } else if (parseInt(church.billingCardInfo.ccExpMo, 10) < curMo) {
        return true;
    };
    return false;
}

const onChangePlanDlgShow = (e) => {

    const currentPlan = plans[plans.findIndex(x => x.id ===
        parseInt(getUrlParam({ key: 'plan', dflt: church.billingSubscriptionParams.billingPlanID }), 10))];

    setPlanOptionsDDL({ billingInterval: currentPlan.billingInterval });
    $('#ddlPlans').val(currentPlan.id);

    $('#ddlBillingInterval').val(currentPlan.billingInterval);
    setTimeout(() => { $('#prorationAlert,#btnPreviewUpdate,#btnUpdatePlan').addClass('hidden'); }, 100);
    updatePlanAmt({ id: currentPlan.id });
    enablePreviewPlanUpdate();

    $('#btnPreviewUpdate').on('click', async () => {
        $('#btnPreviewUpdate').prop('disabled', true);
        const idx = plans.findIndex(x => x.id === parseInt($('#ddlPlans').val(), 10));
        try {
            const invoice = await getPreviewInvoiceAsync({
                custID: church.billingCardInfo.customerID,
                subID: church.billingSubscriptionParams.subscriptionID,
                priceID: plans[idx].planID
            });
            const msg = 'All cost of changing a subscription are prorated to the nearest second.';
            const total = invoice.lines.data.length > 2
                ? invoice.lines.data
                    .filter(x => x.proration === true)
                    .reduce((total, x) => total + x.amount, 0)
                : invoice.lines.data.reduce((total, x) => total + x.amount, 0) + invoice.starting_balance;
            //console.log('previewInvoice', invoice);
            //console.log('previewTotal', total);
            if (total > 0) {
                $('#prorationAlert')
                    .text(`${msg} You will be charged approximately $${(total / 100.00).toFixed(2)} if you change your subscription.`)
                    .removeClass('hidden');
            } else {
                $('#prorationAlert')
                    .text(`${msg} Your account will be credited approximately $${(total * -1 / 100.00).toFixed(2)} if you change your subscription. This credit will be applied to future charges.`)
                    .removeClass('hidden');
            }
            $('#btnPreviewUpdate').addClass('hidden').prop('disabled', false);
            $('#btnUpdatePlan').removeClass('hidden');
        }
        catch (error) { }
    });
}

const onClickCancelMySermonNotesAsync = async () => {
    window.location.href = '../Billing/CancelMsg?status=' +
        church.billingSubscriptionParams.subscriptionStatus + '&pe=' +
        new Date(church.subscriptionExpires).toLocaleDateString();
    await savePromise({
        url: 'Billing/Cancel',
        data: {
            CustomerID: church.billingSubscriptionParams.customerID,
            SubscriptionID: church.billingSubscriptionParams.subscriptionID,
            SubscriptionStatus: church.billingSubscriptionParams.subscriptionStatus
        },
        btnId: '#btnCancelMySermonNotes',
        loaderId: '#loader'
    })
    .then(async () => await refreshTokenForSubscriptionStatusAsync({ tokenNm: 'sNotes' }));
}

const onClickCardUpdateAsync = async () => {
    try {
        const result = await getStripeToken();
        if (result.error) {
            const displayError = document.getElementById('card-errors');
            displayError.textContent = result.error.message;
            return;
        }
        /* update card in stripe using token */
        await savePromise({
            url: 'Billing/Card',
            data: {
                CustomerID: church.billingCardInfo.customerID,
                TokenID: result.token.id,
                CCExpMo: result.token.card.exp_month,
                CCExpYr: result.token.card.exp_year,
                CCLast4: result.token.card.last4
            },
            btnId: '#btnCardUpdate',
            loaderId: '#loader',
            fnErr: () => {
                $('#stripeinput').addClass('hidden');
                $('#btnShowCard').show();
            }
        })
        .then(async () => { /* Refresh portal */
            updateCardInfo({
                ccExpMo: result.token.card.exp_month,
                ccExpYr: result.token.card.exp_year,
                ccLast4: result.token.card.last4
            });
            if (!church.isActive) {
                $('#btnRenewSubscription').removeClass('hidden');
                church.BillingCardInfo.tokenID = result.token.id;
                church.BillingCardInfo.ccExpMo = result.token.card.exp_month;
                church.BillingCardInfo.ccExpYr = result.token.card.exp_year;
                church.BillingCardInfo.ccLast4 = result.token.card.last4;
            }
            $('#stripeinput').addClass('hidden');
            $('#btnShowCard').show();
            updatePlanStatus({
                id: church.billingSubscriptionParams.billingPlanID,
                status: church.billingSubscriptionParams.subscriptionStatus === 3 ? 5 : 1,
                isActive: church.isActive
            });
            await refreshTokenForSubscriptionStatusAsync({ tokenNm: 'sNotes' });
        });
    }
    catch (error) { }
}

const onClickRenewSubscriptionAsync = async () => {
    if (church.isActive) {
        await savePromise({
            url: 'Billing/Renew',
            data: {
                SubscriptionID: church.billingSubscriptionParams.subscriptionID
            },
            beforeSend: snSite.setAuthHdr,
            btnId: '#btnRenewSubscription',
            loaderId: '#loader'
        })
        .then(async () => {
            try {
                await getUpcomingInvoiceAsync(
                    church.billingCardInfo.customerID,
                    church.billingSubscriptionParams.subscriptionID
                ).then(() => {
                    /* Webhook will reset correct subscriptonStatus to 0 for a trial or 1 for active on callback.
                        * Since a subscripton of 0 or 1 displays the same message to the user we just set it to 0 since
                        * the param is only being used to display the message */
                    updateSubscriptionPanel({ status: 0 });
                });
            }
            catch (error) { }
        });
    } else {
        $('#changePlanDlg').modal('show');
    }
}

const onClickFinalizeInvoiceAsync = async () => {
    try {
        const data = await getInvoicesAsync({ subID: church.billingSubscriptionParams.subscriptionID, status: 'draft' });
        const invoices = data.data;
        if (invoices.length > 0) {
            await savePromise({
                url: 'Billing/FinalizeInvoice',
                data: invoices[0].id,
            });
        }
    }
    catch (error) { }
}

const onClickUpdatePlanAsync = async () => {

    $('#btnUpdatePlan').prop('disabled', true);

    const idx = plans.findIndex(x => x.id === parseInt($('#ddlPlans').val(), 10));

    church.billingSubscriptionParams.billingPlanID = plans[idx].id;
    church.billingSubscriptionParams.planID = plans[idx].planID;

    if (church.isActive) {
        await savePromise({
            url: 'Billing/Plan',
            data: {
                CG: token.CG,
                BillingPlanID: church.billingSubscriptionParams.billingPlanID,
                PlanID: church.billingSubscriptionParams.planID,
                SubscriptionID: church.billingSubscriptionParams.subscriptionID,
                CustomerID: church.billingCardInfo.customerID
            }
        })
        .then(async () => {
            const [upcomingInvoiceData, invoicesData] =
                await allSettled({
                    promises: [
                        getUpcomingInvoiceAsync(
                            church.billingCardInfo.customerID,
                            church.billingSubscriptionParams.subscriptionID),
                        getInvoicesAsync({ custID: church.billingCardInfo.customerID, limit: 12 })
                    ]
                });
            if (upcomingInvoiceData.status !== 'rejected') {
                upcomingInvoice = upcomingInvoiceData.value;
                updatePlanStatus({
                    id: church.billingSubscriptionParams.billingPlanID,
                    status: church.billingSubscriptionParams.subscriptionStatus,
                    expires: ctssFormat.formatTimeStampToDateTime({
                        timeStamp: upcomingInvoice.subscription.current_period_end,
                        showDateOnly: true
                    }),
                    isActive: church.isActive
                });
            }
            if (invoicesData.status !== 'rejected') {
                getInvoiceRows({ invoices: invoicesData.value });
                updateCreditBalance({ invoices: invoicesData.value });
            };
            $('#changePlanDlg').modal('hide');
            $('#btnUpdatePlan').prop('disabled', false);
        });
    }
    else {
        await savePromise({
            url: 'Billing/RenewLapsed',
            data: church.billingSubscriptionParams,
            btnId: '#btnUpdatePlan',
        })
        .then(async (status) => {
            if (status === 4) { /* Incomplete suscription creation due to declined payment */
                church.isActive = true;
                updatePlanStatus({
                    id: church.billingSubscriptionParams.billingPlanID,
                    status: 4,
                    isActive: true
                });
            } else {
                try {  
                    const church = await getBillingInfoAsync();
                    updateChurchInfo();
                    await getUpcomingInvoiceAsync(
                        church.billingCardInfo.customerID,
                        church.billingSubscriptionParams.subscriptionID)
                        .then(() => {
                            updateSubscriptionPanel();
                        });
                    await refreshTokenForSubscriptionStatusAsync({ tokenNm: 'sNotes' });
                }
                catch (error) { }                
            }
            $('#changePlanDlg').modal('hide');
            $('#btnUpdatePlan').prop('disabled', false);
        });
    };
}

const updateCardInfo = (params) => {
    $('#existing-card').text('**** **** **** ' + params.ccLast4);
    $('#existing-card-expires').text(params.ccExpMo + '/' + params.ccExpYr);
}

const updateChurchInfo = () => {
    const d = new Date(church.memberSince);
    $('#lblName').text(church.name);
    $('#lblMemberSince').text('Member since: ' + d.toLocaleDateString());
};

const updateCreditBalance = (params) => {
    const invoiceCount = params.invoices.length;
    const creditBalance = invoiceCount > 0
        ? params.invoices[0].ending_balance / 100.00
        : 0.00;
    if (creditBalance === 0.00) {
        $('#lblCreditBalance').addClass('hidden');
    } else {
        if (creditBalance < 0) {
            $('#lblCreditBalance').text(`Credit Balance: $${(creditBalance * -1).toFixed(2)}`).removeClass('hidden');
        }
    }
}

const updatePlanAmt = (params) => {
    const idx = plans.findIndex(x => x.id === params.id);
    const interval = plans[idx].billingInterval === 1
        ? 'annual'
        : 'monthly';
    const p = plans[idx].price;
    $('#lblPlanAmt').text(`Your new ${interval} plan price will be $${p.toFixed(2)}...`);
}

const updatePlanStatus = (params) => {
    const idx = plans.findIndex(x => x.id === params.id);
    $('#lblPlan').text(`Plan: ${plans[idx].description}`);
    let msg = '';
    if (params.isActive === false) {
        msg = 'Your subscription has expired...';
        if (isCardExpired()) {
            msg += ' You can renew it by updating your card and then renewing your subscription.'
        }
    } else if (params.status === 0 || params.status === 1) {
        const expires = typeof params.expires === 'string'
            ? params.expires
            : params.expires.toLocaleDateString();
        msg = `You will be charged $${plans[idx].price} on ${expires}...`;
    } else if (params.status === 2) {
        msg = `Your supscription will expire on ${params.expires.toLocaleDateString()}...`;
    } else if (params.status === 3) {
        msg = 'Your subscription is past due.  Please update ' +
            `your card by ${params.paymentGraceDate.toLocaleDateString()} to ensure uninterupted service...`;
    } else if (params.status === 4) {
        msg = "Please update your card to complete the subscription renewal process...";
        $('#btnRenewSubscription').addClass('hidden');
    } else if (params.status === 5) {
        msg = "Your card will be charged soon...";
    } else {
        msg = 'Subscription status unknown - Please contact support@mysermonnotes.com';
    }
    params.status === 3 || params.status === 4
        ? $('#lblPlanStatus').text(msg).css('color', 'Red')
        : $('#lblPlanStatus').text(msg).css('color', '');
}

const updateSubscriptionMenu = (params) => {
    if (params.isActive === false) {
        $('#btnChangePlan').addClass('hidden');
        $('#btnCancelSubscription').addClass('hidden');
        $('#btnRenewSubscription').removeClass('hidden');
    } else if (params.status === 0 || params.status === 1) {
        $('#btnChangePlan').removeClass('hidden');
        $('#btnCancelSubscription').removeClass('hidden');
        $('#btnRenewSubscription').addClass('hidden');
    } else if (params.status === 2) {
        $('#btnChangePlan').addClass('hidden');
        $('#btnCancelSubscription').addClass('hidden');
        $('#btnRenewSubscription').removeClass('hidden');
    } else if (params.status === 3) {
        $('#btnChangePlan').addClass('hidden');
        $('#btnCancelSubscription').removeClass('hidden');
        $('#btnRenewSubscription').addClass('hidden');
    } else {
        $('#btnChangePlan').addClass('hidden');
        $('#btnCancelSubscription').addClass('hidden');
        $('#btnRenewSubscription').addClass('hidden');
    }

}

const updateSubscriptionPanel = (params = {}) => {

    const status = params.status ?? church.billingSubscriptionParams.subscriptionStatus;

    isCardExpired()
        ? $('#btnRenewSubscription').addClass('hidden')
        : $('#btnRenewSubscription').removeClass('hidden');

    updatePlanAmt({ id: church.billingSubscriptionParams.billingPlanID });

    updatePlanStatus({
        id: church.billingSubscriptionParams.billingPlanID,
        status: status,
        expires: new Date(church.subscriptionExpires),
        paymentGraceDate: new Date(church.paymentGraceDate),
        isActive: church.isActive
    });

    updateSubscriptionMenu({
        isActive: church.isActive,
        status: status
    });
}

///* Public variables and functions */

let church;
let plans;
let upcomingInvoice;

const changeBillingIntervalDDL = (params = {}) => {

    const ddlBillingInterval = params.ddlBillingInterval ?? 'ddlBillingInterval';
    const ddlPlans = params.ddlPlans ?? 'ddlPlans';

    const billingInterval = parseInt($(`#${ddlBillingInterval}`).val(), 10);
    const billingIntervalPlans = getBillingIntervalPlans(billingInterval);
    const maxUsers = plans[plans.findIndex(x => x.id === parseInt($(`#${ddlPlans}`).val(), 10))].maxUsers;
    setPlanOptionsDDL({ billingInterval: billingInterval });
    $(`#${ddlPlans}`).val(billingIntervalPlans[billingIntervalPlans.findIndex(x => x.maxUsers === maxUsers)].id);
}

const getPlansDDLAsync = async () =>
    await getPromise({ url: 'Billing/Plans' }); 

const initCancelMsg = () => {

    const status = getUrlParam({ key: 'status', dflt: '3' });
    const periodEnding = getUrlParam({ key: 'pe', dflt: 'unknown' });
    const msg = status === '3'
        ? 'Your subscription has expired'
        : `Your subscription will remain active until ${periodEnding}`;
    $('#lblSubscriptionStatus').text(msg);

    $('#btnHome').on('click', async () => {
        await refreshTokenForSubscriptionStatusAsync({ tokenNm: 'sNotes' });
        window.location.href = '../Home';
    });

    $('#btnBilling').on('click', async () => {
        await refreshTokenForSubscriptionStatusAsync({ tokenNm: 'sNotes' });
        window.location.href = '../Billing';
    });
};

const setPlanOptionsDDL = (params = {}) => {

    const ctrlId = params.ctrlId ?? 'ddlPlans';

    if (params.billingInterval === undefined) {
        showMySNError({ errMsg: 'Unable to set PlanOptionsDDL.  Please contact support@mysermonnotes.com' });
        return;
    }
    bindSelect({
        id: ctrlId,
        items: getBillingIntervalPlans(params.billingInterval),
        valueNm: 'id',
        textNm: 'description'
    });
};

const initAsync = async () => {
    setMenu();

    const [billingInfoData, plansData] =
        await allSettled({
            promises: [
                getBillingInfoAsync(),
                getPlansDDLAsync()
            ]
        });

    if (billingInfoData.status !== 'rejected') {
        church = billingInfoData.value;
        updateChurchInfo();
        if (church.isActive === false || church.billingSubscriptionParams.subscriptionStatus === 2) {
            updateSubscriptionPanel();
        } else {
            await getUpcomingInvoiceAsync(
                church.billingCardInfo.customerID,
                church.billingSubscriptionParams.subscriptionID)
                .then((upcomingInvoice) => {
                    upcomingInvoice = upcomingInvoice;
                    updateSubscriptionPanel()
                });
        }

    }
    if (plansData.status !== 'rejected') {
        plans = plansData.value;
    };

    $('#ddlBillingInterval').on('change', () => {
        changeBillingIntervalDDL({});
        updatePlanAmt({ id: parseInt($('#ddlPlans').val(), 10) });
        enablePreviewPlanUpdate();
    });

    $('#ddlPlans').on('input', () => {
        updatePlanAmt({ id: parseInt($('#ddlPlans').val(), 10) });
        enablePreviewPlanUpdate();
    });

    buildStripeCard({ btnNm: 'btnCardUpdate' });

    $('#btnShowCard').on('click', () => {
        clearStripeCard();
        $('#stripeinput').removeClass('hidden');
        $('#btnShowCard').hide();
    });

    $('#btnCardCancel').on('click', () => {
        $('#stripeinput').addClass('hidden');
        $('#btnShowCard').show();
    });


    $('#btnCardUpdate').on('click', onClickCardUpdateAsync);
    $('#changePlanDlg').on('show.bs.modal', onChangePlanDlgShow);
    $('#btnUpdatePlan').on('click', onClickUpdatePlanAsync);
    $('#btnCancelMySermonNotes').on('click', onClickCancelMySermonNotesAsync);
    $('#btnRenewSubscription').on('click', onClickRenewSubscriptionAsync);
    $('#btnFinalizeInvoice').on('click', onClickFinalizeInvoiceAsync);
};

export {
    changeBillingIntervalDDL,
    getPlansDDLAsync,
    getInvoiceRows,
    setPlanOptionsDDL
}

window.snBilling = {
    initAsync,
    initCancelMsg
};

